import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { COUNTRY_CODES } from "../../constants/countryCodes";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  label: {
    marginTop: typography.pxToRem(37),
    marginBottom: 10,
    fontSize: typography.pxToRem(20),
    fontWeight: 300,
    letterSpacing: typography.pxToRem(0.44),
    color: palette.text.headline,
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(16),
      marginTop: typography.pxToRem(20)
    }
  },
  text: {
    fontSize: typography.pxToRem(15),
    letterSpacing: typography.pxToRem(0.44),
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(13)
    }
  },
  driverFavoriteAndCountry: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    [breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr"
    }
  },
  country: {
    [breakpoints.up("md")]: {
      paddingLeft: 30
    }
  }
}));
export default (({
  driverName,
  favouriteTune,
  countryCode,
  specialConsiderations
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.driverFavoriteAndCountry
  }, favouriteTune && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.label
  }, driverName, "\u2019s favourite tune"), /*#__PURE__*/React.createElement(Typography, {
    className: styles.text
  }, favouriteTune)), countryCode && /*#__PURE__*/React.createElement("div", {
    className: styles.country
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.label
  }, driverName, "\u2019s country of origin"), /*#__PURE__*/React.createElement(Typography, {
    className: styles.text
  }, COUNTRY_CODES[countryCode]))), specialConsiderations && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.label
  }, "Special considerations"), /*#__PURE__*/React.createElement(Typography, {
    className: styles.text
  }, specialConsiderations)));
});